import { ActionButton, Stack } from '@fluentui/react'
import { Link } from 'react-router-dom'
import styles from './Header.module.css'
import { useSidebarContext } from '../../state/SidebarProvider'
import { useContext } from 'react'
import { AppStateContext } from '../../state/AppProvider'
import { LogoSammy } from '../../assets'

export const Header = () => {
  const { toggleSidebar } = useSidebarContext()
  const appStateContext = useContext(AppStateContext)
  const title = appStateContext?.state.frontendSettings?.ui?.title || ''

  return (
    <header role={'banner'} style={{ paddingTop: '24px' }}>
      <Stack horizontal verticalAlign="center">
        <ActionButton
          iconProps={{ iconName: 'MenuIcon' }}
          styles={{ icon: { margin: 0, width: '24px', height: '24px' } }}
          className={styles.burgerMenuBtn}
          onClick={toggleSidebar}>
        </ActionButton>
        <Stack horizontal verticalAlign="center" className={styles.logoWrapper}>
          <Link to="/" className={styles.headerTitleContainer}>
            <img src={LogoSammy} alt="Ask SAMMY" />
          </Link>
        </Stack>
      </Stack>
    </header>
  )
}
